import * as yup from 'yup';
import { ErrorMsg, MaxFileSizeLimit } from '../helpers/contants';
import {
  businessType,
  PRODUCT_TYPES,
  RENTAL_SERVICE_TYPE,
} from './constantData';
export const regexForZipcode = /^[A-Za-z0-9\s]+$/;
export const emailRegex =
  /^[a-zA-Z0-9_+]+(\.[a-zA-Z0-9_+]+)*@[a-zA-Z0-9_+]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
// const startDate = yup
//   .string()
//   .required(ErrorMsg('From Date').required)
//   .test(
//     'is-not-empty',
//     ErrorMsg('From Date').required,
//     (value) => !!value && value.trim() !== ''
//   )

// const endDate = yup
//   .string()
//   .required(ErrorMsg('To Date').required)
//   .test(
//     'is-not-empty',
//     ErrorMsg('To Date').required,
//     (value) => !!value && value.trim() !== ''
//   )
const startDateEpisode = yup
  .string()
  .required('Start Date is required')
  .typeError('Start Date must be a valid date');

const endDateEpisode = yup
  .string()
  .required(ErrorMsg('End Date').required)
  .test(
    'is-not-empty',
    ErrorMsg('End Date').required,
    value => !!value && value.trim() !== '',
  )
  .test(
    'is-after-start',
    'End date must be after or equal to the start date',
    function (endDate) {
      const { startDate } = this.parent;
      if (!startDate || !endDate) return true;
      return parseInt(endDate) >= parseInt(startDate); // Allow equal dates
    },
  );

export const RegisterFormSchema = yup
  .object({
    firstName: yup
      .string()
      .required(ErrorMsg('First Name').required)
      .min(2, ErrorMsg(2).min)
      .max(25, ErrorMsg(25).max)
      .matches(/^[a-zA-Z\s]+$/, ErrorMsg('First Name').onlyLetter),

    lastName: yup
      .string()
      .required('Last Name is required.')
      .min(2, ErrorMsg(2).min)
      .max(25, ErrorMsg(25).max)
      .matches(
        /^[a-zA-Z\s]+$/,
        'Last Name should only contain letters and spaces',
      ),

    email: yup
      .string()
      .required('Email is required.')
      .matches(
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
        'Please enter a valid email.',
      )
      .max(50, 'Email must be at most 50 characters long.')
      .email('Please enter valid email.'),
    countryCode: yup.object(),
    // countryAbbreviation: yup.string(),

    // password: yup
    //   .string()
    //   .min(8, 'Password must be at least 8 characters long')
    //   .max(128, 'Password must be less than 128 characters long')
    //   .matches(
    //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,128}$/,
    //     'Password must be at least 8-128 characters long and include at least one uppercase letter, one lowercase letter, one special character, and one number.'
    //   )
    //   .required('Password is required.'),
    // confirmPassword: yup
    //   .string()
    //   .oneOf(
    //     [yup.ref('password'), ''],
    //     'Password and confirm password should match.'
    //   )
    //   .required('Confirm Password is required.'),
    phoneNo: yup
      .string()
      .min(5, 'Mobile Numbers should be Min 5 and Max 13 characters.')
      .max(13, 'Mobile Numbers should be Min 5 and Max 13 characters.'),
    termsAndConditions: yup
      .boolean()
      .oneOf([true], 'You must accept the Terms and Conditions'),
  })
  .required();

export const BusinessSchema = yup
  .object({
    businessLocation: yup
      .object()
      .typeError(ErrorMsg('Business Location').required)
      .required(ErrorMsg('Business Location').required),
    businessType: yup
      .string()
      .required(ErrorMsg('Business Type').required)
      .default(businessType[0]),
    businessName: yup
      .string()
      .required('Business Name is required')
      .matches(
        /^[a-zA-Z0-9_\s]+$/,
        'Value can only contain letters, numbers, and underscores',
      )
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).min),
    department: yup
      .array()
      .min(1, 'Select at least one value')
      .required('Select at least one value'),
    businessAddress: yup
      .string()
      .required('Address is required')
      .max(500, 'Address must be at most 500 characters long'),
    businessZipCode: yup
      .string()
      .matches(regexForZipcode, 'Invalid Zip code.')
      .required('Zip code is required.')
      .max(10, 'Invalid Zip code.'),
  })
  .required();

export const ContactInfoSchema = yup
  .object({
    firstName: yup
      .string()
      .required('First Name is required')
      .matches(/^[a-zA-Z]+$/, 'First Name should only contain letters')
      .min(2, ErrorMsg(2).min)
      .max(50, ErrorMsg(50).max),
    middleName: yup
      .string()
      .transform((value, originalValue) => {
        return originalValue === '' ? null : value;
      })
      .matches(/^[a-zA-Z]*$/, 'Middle Name should only contain letters')
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max)
      .nullable(),
    lastName: yup
      .string()
      .required('Last Name is required')
      .min(2, ErrorMsg(2).min)
      .max(50, ErrorMsg(50).max)
      .matches(/^[a-zA-Z]+$/, 'Last Name should only contain letters'),
    dob: yup
      .string()
      .test('validDateOfBirth', 'Invalid date of birth', function (value) {
        if (!value) return true; // Allow empty input
        const today = new Date();
        const dob = new Date(value);
        const age = today.getFullYear() - dob.getFullYear();
        if (dob > today || age < 18) {
          return false;
        }
        return true;
      })
      .required('Date of birth is required'),
    zipCode: yup
      .string()
      .matches(regexForZipcode, 'Invalid Zip code.')
      .required('Zip code is required.')
      .max(10, 'Invalid Zip code.'),
    city: yup
      .string()
      .required('City is required')
      .matches(/^[a-zA-Z\s]+$/, 'Only alphabets are allowed.')
      .max(30, 'City must be at most 30 characters long'),
    state: yup.string().required('State is required'),
    addressLineOne: yup
      .string()
      .required('Address is required')
      .max(500, 'Address must be at most 500 characters long'),
    addressLineTwo: yup
      .string()
      .max(500, 'Address must be at most 500 characters long'),
    country: yup.object().required('Country is required'),
    // business_location: yup.object().required('Country is required'),
  })
  .required();

export const AddEpisodes = yup
  .object({
    contacts: yup.array(),
    productionId: yup
      .mixed()
      .test(
        'is-valid-productionId',
        'Project is required.',
        value =>
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' || typeof value === 'object'),
      )
      .required('Project is required.'), // Ensure a value is always provided
    name: yup
      .string()
      .required('Episode/Event Name is required.')
      .min(3, 'Episode/Event Name must be at least 3 characters.')
      .max(50, 'Episode/Event Name cannot exceed 50 characters.'),

    episodeNumber: yup
      .string()
      .notRequired()
      .max(25, 'Episode/Event Number cannot exceed 25 characters.'),

    startDate: startDateEpisode,
    episodeId: yup.mixed().nullable(), // Ensure a value is always provided
    endDate: endDateEpisode,
    // .min(new Date(),"Date must be in the future."),
    associatedPONumber: yup
      .string()
      .min(2, ErrorMsg(2).min)
      .max(25, 'PO Number cannot exceed 25 characters.'),
    image: yup.string(),
    // documents: yup.array().of(
    //   yup.object({
    //     deptId: yup.string(),
    //     docName: yup.string(),
    //     docFormat: yup.string(),
    //     documentUrl: yup.string().url('Invalid URL'),
    //   })
    // ),
    // business_location: yup.object().required('Country is required'),
  })
  .required();

export const AddDepartment = yup.object({
  deptName: yup
    .string()
    .required('Department Name is required')
    .max(50, 'Department Name cannot exceed 50 characters'),
  description: yup
    .string()
    // .required('Description is required')
    .max(1000, 'Description cannot exceed 1000 characters'),
});

export const AddLocations = yup
  .object({
    location: yup.mixed().nullable().required('Location is required.'),
    nickname: yup.string().max(25, 'Nick Name should be max 25 characters.'),
    postalCode: yup.string().required('Postal Code is required.'),
    addressLine1: yup.string().required('Address Line 1 is required.'),
    addressLine2: yup.string(),
    stateProvince: yup.string().required('State is required.'),
    cityTown: yup.string().required('City is required.'),
    latitude: yup.string().required('Latitude is required.'),
    locationName: yup.string().required('Location Name is required.'),
    // .max(50, 'Location Name should be max 50 characters.'),
    longitude: yup.string().required('Longitude is required.'),
    productionId: yup.mixed().nullable().required('Project is required.'),
    episodeId: yup.mixed().when('productionId', ([productionId], schema) => {
      return productionId?.type === 'TV Series'
        ? schema.required('Episode/Event Name is required.')
        : schema.nullable();
    }),
    setIds: yup
      .array()
      .min(1, 'Sets/Activities is required.')
      .required('Sets/Activities is required.'),
    locationPurpose: yup
      .array()
      .min(1, 'Purpose is required.')
      .required('Purpose is required.'),
    notes: yup.string(),
    image: yup.mixed(),
    documents: yup.array().of(
      yup.object({
        deptId: yup.string().nullable(),
        docName: yup.string(),
        docFormat: yup.string(),
        documentUrl: yup.string().url('Invalid URL'),
      }),
    ),
  })
  .required();

export const LegalDocSchema = yup
  .object({
    documentType: yup.string().required('Document Type is required.'),
    document: yup
      .mixed()
      .test(
        'fileExtension',
        'Only png/jpg/jpeg/pdf/doc/docx file type allowed.',
        (value: any) => {
          if (!value) return true; // Allow empty input
          const supportedFileTypes = [
            'png',
            'jpg',
            'jpeg',
            'pdf',
            'doc',
            'docx',
            'msword',
          ];
          const fileName = value.name;
          const fileExtension = fileName.slice(
            ((fileName.lastIndexOf('.') - 1) >>> 0) + 2,
          );
          return supportedFileTypes.includes(fileExtension);

          // return supportedFileTypes.includes(fileType)
        },
      )
      .test('fileSize', 'Max. 3 MB file size allowed.', (value: any) => {
        if (!value) return true; // Allow empty input

        return value.size <= MaxFileSizeLimit;
      })
      .required('Document is required'),
    documentNumber: yup
      .string()
      .required('Document Number is required')
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max)
      .matches(/^[a-zA-Z0-9]+$/, 'Special characters are not allowed'),
    countryOfIssue: yup.object().required('Country of issue is required'),
    dateOfExp: yup.string().required('Date of expire is required'),
  })
  .required();

export const fileSchema = yup.object({
  document: yup
    .mixed()
    .test(
      'fileType',
      'Only png/jpg/jpeg/pdf/doc/docx file type allowed.',
      (value: any) => {
        if (!value) return true; // Allow empty input
        const supportedFileTypes = [
          'png',
          'jpg',
          'jpeg',
          'pdf',
          'doc',
          'docx',
          'msword',
          'vnd.openxmlformats-officedocument.wordprocessingml.document',
        ];
        const fileType = value.type.split('/')[1]; // Extract file extension from MIME type
        return supportedFileTypes.includes(fileType);
      },
    )
    .test('fileSize', 'Max. 3 MB file size allowed.', (value: any) => {
      if (!value) return true; // Allow empty input
      return value.size <= MaxFileSizeLimit;
    }),
});

export const thumbnailSchma = yup.object({
  file: yup
    .mixed()
    .test(
      'fileType',
      'Only PNG, JPG, JPEG, and PDF file types are allowed for document upload',
      (value: any) => {
        if (!value) return true; // Allow empty input
        const supportedFileTypes = [
          'png',
          'jpg',
          'jpeg',
          'pdf',
          'heic',
          'heif',
        ];
        const fileType = value.type.split('/')[1]; // Extract file extension from MIME type
        return supportedFileTypes.includes(fileType);
      },
    )
    .test('fileSize', 'Max. 3 MB file size allowed.', (value: any) => {
      if (!value) return true; // Allow empty input
      return value.size <= MaxFileSizeLimit;
    }),
});

export const pdfSchema = yup.object({
  file: yup
    .mixed()
    .test('fileType', 'Only PDF files are allowed.', (value: any) => {
      if (!value) return true; // Allow empty input
      const fileType = value.type?.split('/')[1]; // Extract file extension from MIME type
      return fileType === 'pdf';
    }),
  // .test('fileSize', 'Max. 5 MB file size allowed.', (value: any) => {
  //   if (!value) return true // Allow empty input
  //   const MaxFileSizeLimit = 5 * 1024 * 1024 // 5 MB limit in bytes
  //   return value.size <= MaxFileSizeLimit
  // }),
});
export const LoginFormSchema = yup
  .object({
    phoneNo: yup
      .string()
      .required(ErrorMsg('Mobile number').required)
      .min(5, 'Mobile Numbers should be Min 5 and Max 13 characters.')
      .max(13, 'Mobile Numbers should be Min 5 and Max 13 characters.'),
    countryCode: yup.object(),
    countryAbbreviation: yup.string(),
  })
  .required();
export const forgotPasswordSchema = yup
  .object({
    email: yup
      .string()
      .required('Email is required.')
      .matches(emailRegex, 'Please enter a valid email.')
      .max(100, 'Email must be at most 100 characters long.')
      .email('Please enter a valid email.'),
  })
  .required();
import dayjs from 'dayjs';

// async function validateFileSize(url: string, maxFileSize: any) {
//   try {
//     const response = await axios.head(url) // Use HEAD request
//     const fileSize = response.headers['content-length'] // Get file size from headers

//     if (fileSize) {
//       console.log(`File size: ${fileSize} bytes`)
//       return parseInt(fileSize, 10) <= maxFileSize
//     }

//     throw new Error('Unable to determine file size')
//   } catch (error) {
//     console.error('Error fetching file size:', error)
//     return false
//   }
// }

// const scheduleType = yup
//   .string()
//   .required(ErrorMsg('Schedule Type').required)
//   .test(
//     'is-not-empty',
//     ErrorMsg('Schedule Type').required,
//     (value) => !!value && value.trim() !== ''
//   )

export const createSetSchema = yup
  .object({
    name: yup
      .string()
      .required(ErrorMsg('Set/Activity Name').required)
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max),
    productionId: yup
      .mixed()
      .test(
        'is-valid-productionId',
        'Project is required.',
        value =>
          value !== undefined &&
          value !== null &&
          (typeof value === 'string' || typeof value === 'object'),
      )
      .required('Project is required.'), // Ensure a value is always provided
    associatedPONumber: yup
      .string()
      .transform(value => (value === '' ? null : value)) // 👈 key fix
      .notRequired()
      .min(2, ErrorMsg(2).min)
      .max(25, 'PO Number cannot exceed 25 characters.'),
    episodeId: yup
      .mixed()
      .nullable()
      .test(
        'is-valid-episodeId',
        `Episode/Event is required.`,
        function (value) {
          const { productionId } = this.parent;

          console.log(productionId, 'productionId');

          // If productionId is a TV Series, validate episodeId
          const isTVSeries =
            (Array.isArray(productionId) &&
              (productionId[0]?.type === 'TV Series' ||
                productionId[0]?.type === 'Multiple Live Events')) ||
            productionId?.type === 'TV Series' ||
            productionId?.type === 'Multiple Live Events';

          if (isTVSeries) {
            return (
              value !== undefined &&
              value !== null &&
              value !== '' &&
              (typeof value === 'string' || typeof value === 'object')
            );
          }

          // Otherwise, episodeId can be null/empty
          return true;
        },
      ),

    sceneDescription: yup
      .string()
      .nullable() // Allows null or undefined values
      .notRequired() // Makes the field optional
      .test(
        'notes-length',
        'Description must be between 3 and 1000 characters.',
        value => !value || (value.length >= 3 && value.length <= 1000),
      ),
    notes: yup
      .string()
      .nullable() // Allows null or undefined values
      .notRequired() // Makes the field optional
      .test(
        'notes-length',
        'Notes must be between 3 and 1000 characters.',
        value => !value || (value.length >= 3 && value.length <= 1000),
      ),
    scriptPageNumbers: yup
      .string()
      // .typeError('Script Page Numbers must be a number')
      .test(
        'max-digits',
        'Script Page Numbers must be at most 500 characters.',
        value => !value || value.toString().length <= 500,
      )
      .nullable(),

    sceneNumber: yup
      .string()
      // .typeError('Scene Number must be a number.')
      .test(
        'max-digits',
        'Scene Number must be at most 500 characters.',
        value => !value || value.toString().length <= 500,
      )
      .nullable(),
    // documents: yup.array().of(
    //   yup.object({
    //     deptId: yup.string(),
    //     docName: yup.string(),
    //     docFormat: yup.string(),
    //     documentUrl: yup.string().url('Invalid URL'),
    //   }),
    // ),
    schedule: yup
      .array()
      .of(
        yup.object().shape({
          scheduleType: yup.string().required('Please select Type.'),
          startDate: yup.string().required(ErrorMsg('From Date').required),
          endDate: yup
            .string()
            .required(ErrorMsg('To Date').required)
            .test(
              'is-endDate-valid',
              'To date should not be before from date',
              function (endDate) {
                const { startDate } = this.parent;
                if (!startDate) return true;
                // console.log(
                //   dayjs(endDate).isAfter(dayjs(startDate)),
                //   'lkefkb',
                //   endDate,
                //   startDate
                // );
                const start = dayjs(new Date(startDate));
                const end = dayjs(new Date(endDate));

                if (!start.isValid() || !end.isValid()) return true;

                return end.isAfter(start) || end.isSame(start);
              },
            ),
        }),
      )
      .min(1, 'At least one entry is required.'),

    contacts: yup.array(),
    image: yup.string(),
  })
  .required();

yup.addMethod(yup.array, 'uniqueSchedule', function (message, mapper) {
  return this.test('unique', message, function (list) {
    if (!Array.isArray(list)) return true;

    const map: any = {};
    for (let i = 0; i < list.length; i++) {
      const item = mapper(list[i]);
      if (map[item]) {
        return this.createError({
          path: `${this.path}[${i}].scheduleType`,
          message,
        });
      }
      map[item] = true;
    }
    return true;
  });
});

yup.addMethod(yup.array, 'uniqueEmail', function (message, mapper) {
  return this.test('unique', message, function (list) {
    if (!Array.isArray(list)) return true;

    const map: any = {};
    for (let i = 0; i < list.length; i++) {
      const item = mapper(list[i]);
      if (map[item]) {
        return this.createError({
          path: `${this.path}[${i}].email`,
          message,
        });
      }
      map[item] = true;
    }
    return true;
  });
});

export const CreateProductionFormSchema = yup
  .object({
    name: yup
      .string()
      .required(ErrorMsg('Project Name').required)
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max),
    description: yup.string().max(1000, ErrorMsg(1000).max),
    // .required(ErrorMsg('Description').required),
    type: yup.mixed().required('Please select Type.'),
    customProductionType: yup.string().when('type', ([type], schema) => {
      // console.log('TYPEEE=>', type, schema)
      return type === 'Other'
        ? schema.required('Custom Project Type is required')
        : schema.nullable();
    }),
    address: yup.object().required(ErrorMsg('Location').required),
    locationName: yup
      .mixed()
      .test(
        'locationName',
        ErrorMsg('Location Name').required,
        function (value) {
          return (
            (typeof value === 'string' && value.trim() !== '') ||
            (typeof value === 'object' && value !== null)
          );
        },
      )
      .required(ErrorMsg('Location Name').required),
    // .max(100, ErrorMsg(100).max),
    zipCode: yup
      .string()
      .required(ErrorMsg('ZipCode').required)
      .max(25, ErrorMsg(25).max),
    addressLine1: yup.string().required('Address Line 1 is required.'),
    addressLine2: yup.string(),

    latitude: yup.string().required('Latitude is required.'),

    // .max(50, 'Location Name should be max 50 characters.'),
    longitude: yup.string().required('Longitude is required.'),
    city: yup
      .string()
      .required(ErrorMsg('City').required)
      .max(50, ErrorMsg(50).max),
    // country: yup.string().required(ErrorMsg('Country').required),
    state: yup
      .string()
      .max(50, ErrorMsg(50).max)
      .required(ErrorMsg('State').required),
    studio: yup.array().max(10, 'You can only add up to 10 studios'),
    // .min(1),
    // .required('at least one item needs to be here'),
    schedule: yup
      .array()
      .of(
        yup.object().shape({
          scheduleType: yup.object().required('Please select Type.'),
          startDate: yup.string().required(ErrorMsg('From Date').required),
          endDate: yup
            .string()
            .required(ErrorMsg('To Date').required)
            .test(
              'is-endDate-valid',
              'To date should not be before from date',
              function (endDate) {
                const { startDate } = this.parent;
                if (!startDate) return true;
                return (
                  dayjs(endDate).isAfter(dayjs(startDate)) ||
                  dayjs(endDate).isSame(dayjs(startDate))
                );
              },
            ),
        }),
      )
      .uniqueSchedule(
        'Schedule types must be unique.',
        (item: any) => item?.scheduleType?.value,
      ),

    // .uniqueSchdule(
    //   'The field should be unique.',
    //   (item: any) => item?.scheduleType
    // )
    // .test(
    //   'atLeastOneValue',
    //   'At least one value is required',
    //   function (value) {
    //     if (Array.isArray(value)) {
    //       return value.length > 0
    //     }
    //     // Handle other types if needed
    //     return false
    //   }
    // ),
    clients: yup
      .array()
      .of(
        yup.object().shape({
          firstName: yup
            .string()
            .when('phoneNo', {
              is: (phoneNo: any) => (phoneNo ? true : false),
              // Build on the passed-in schema — returning a fresh
              // yup.string() would drop the .max(50) chained below
              then: schema => schema.required(ErrorMsg('First Name').required),
              otherwise: schema => schema,
            })
            // .required(ErrorMsg('First Name').required)
            .max(50, ErrorMsg(50).max),
          lastName: yup
            .string()
            .when('phoneNo', {
              is: (phoneNo: any) => (phoneNo ? true : false),
              then: schema => schema.required(ErrorMsg('Last Name').required),
              otherwise: schema => schema,
            })
            // .required(ErrorMsg('Last Name').required)
            .max(50, ErrorMsg(50).max),
          email: yup.string().when('phoneNo', {
            is: (phoneNo: any) => (phoneNo ? true : false),
            then: () =>
              yup
                .string()
                .required(ErrorMsg('Email').required)
                .matches(
                  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
                  'Please enter a valid email.',
                ),
            otherwise: () => yup.string(),
          }),
          phoneNo: yup
            .string()
            .test('required', 'Phone no less then 5 digits', value => {
              if (!value) {
                return true;
              } else {
                return value.length > 4;
              }
            })
            .max(13, ErrorMsg(13).max),
          countryCode: yup.object(),

          // .max(10, ErrorMsg(10).max),
          isDisabled: yup.boolean(),
        }),
      )
      .uniqueEmail('Email must be unique.', (item: any) => item?.email),
    // .test(
    //   'atLeastOneValue',
    //   'At least one value is required',
    //   function (value) {
    //     if (Array.isArray(value)) {
    //       return value.length > 0
    //     }
    //     // Handle other types if needed
    //     return false
    //   }
    // ),
  })
  .required();

export const CreateStudioFormSchema = yup
  .object({
    name: yup
      .string()
      .required(ErrorMsg('Studio Name').required)
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max),
    description: yup.string().max(1000, ErrorMsg(1000).max),

    address: yup.object().required(ErrorMsg('Location').required),
    locationName: yup
      .mixed()
      .test(
        'locationName',
        ErrorMsg('Location Name').required,
        function (value) {
          return (
            (typeof value === 'string' && value.trim() !== '') ||
            (typeof value === 'object' && value !== null)
          );
        },
      )
      .required(ErrorMsg('Location Name').required),
    // .max(100, ErrorMsg(100).max),
    zipCode: yup
      .string()
      .required(ErrorMsg('ZipCode').required)
      .max(25, ErrorMsg(25).max),
    addressLine1: yup.string().required('Address Line 1 is required.'),
    addressLine2: yup.string(),

    latitude: yup.string().required('Latitude is required.'),

    // .max(50, 'Location Name should be max 50 characters.'),
    longitude: yup.string().required('Longitude is required.'),
    city: yup
      .string()
      .required(ErrorMsg('City').required)
      .max(50, ErrorMsg(50).max),
    // country: yup.string().required(ErrorMsg('Country').required),
    state: yup
      .string()
      .max(50, ErrorMsg(50).max)
      .required(ErrorMsg('State').required),

    clients: yup
      .array()
      .of(
        yup.object().shape({
          firstName: yup
            .string()
            .when('phoneNo', {
              is: (phoneNo: any) => (phoneNo ? true : false),
              // Build on the passed-in schema — returning a fresh
              // yup.string() would drop the .max(50) chained below
              then: schema => schema.required(ErrorMsg('First Name').required),
              otherwise: schema => schema,
            })
            // .required(ErrorMsg('First Name').required)
            .max(50, ErrorMsg(50).max),
          lastName: yup
            .string()
            .when('phoneNo', {
              is: (phoneNo: any) => (phoneNo ? true : false),
              then: schema => schema.required(ErrorMsg('Last Name').required),
              otherwise: schema => schema,
            })
            // .required(ErrorMsg('Last Name').required)
            .max(50, ErrorMsg(50).max),
          email: yup.string().when('phoneNo', {
            is: (phoneNo: any) => (phoneNo ? true : false),
            then: () =>
              yup
                .string()
                .required(ErrorMsg('Email').required)
                .matches(
                  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
                  'Please enter a valid email.',
                ),
            otherwise: () => yup.string(),
          }),
          phoneNo: yup
            .string()
            .test('required', 'Phone no less then 5 digits', value => {
              if (!value) {
                return true;
              } else {
                return value.length > 4;
              }
            })
            .max(13, ErrorMsg(13).max),
          countryCode: yup.object(),

          // .max(10, ErrorMsg(10).max),
          isDisabled: yup.boolean(),
        }),
      )
      .uniqueEmail('Email must be unique.', (item: any) => item?.email),
    // .test(
    //   'atLeastOneValue',
    //   'At least one value is required',
    //   function (value) {
    //     if (Array.isArray(value)) {
    //       return value.length > 0
    //     }
    //     // Handle other types if needed
    //     return false
    //   }
    // ),
  })
  .required();

export const addContactSchema = yup
  .object({
    roleName: yup
      .string()
      .min(3, ErrorMsg(3).min)
      .max(50, ErrorMsg(50).max)
      .required(ErrorMsg('Job Title').required),
    staticRoleId: yup.string().required('Please select Type.'),
    departmentId: yup.object().required('Please select Type.'),
    baseRole: yup.string(),
    departmentName: yup.string(),
    firstName: yup
      .string()
      .required(ErrorMsg('First Name').required)
      // .required(ErrorMsg('First Name').required)
      .max(50, ErrorMsg(50).max),
    lastName: yup
      .string()
      .required(ErrorMsg('Last Name').required)
      // .required(ErrorMsg('Last Name').required)
      .max(50, ErrorMsg(50).max),
    email: yup
      .string()
      .required(ErrorMsg('Email').required)
      .matches(
        /^[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/,
        'Please enter a valid email.',
      )
      .max(100, ErrorMsg(100).max),
    phoneNo: yup
      .string()
      .required(ErrorMsg('Phone number').required)
      .test('required', 'Phone no less then 5 digits', value => {
        if (!value) {
          return true;
        } else {
          return value.length > 4;
        }
      })
      .max(13, ErrorMsg(13).max),
    countryCode: yup.string().max(10, ErrorMsg(10).max),
  })
  .required();

export const addContactSetSchema = yup
  .object({
    roleName: yup
      .mixed()
      // Let null (e.g. cleared on department change) reach the test below,
      // instead of yup's own "roleName cannot be null" message
      .nullable()
      .test('is-valid-roleName', ErrorMsg('Job Title').required, value => {
        // If it's a string, validate the string
        if (typeof value === 'string') {
          return value.length >= 3 && value.length <= 50;
        }
        // If it's an object, validate the roleName property
        if (typeof value === 'object' && value !== null) {
          const roleName = (value as any).roleName;
          return (
            typeof roleName === 'string' &&
            roleName.length >= 3 &&
            roleName.length <= 50
          );
        }
        return false;
      }),
    isContact: yup.boolean(),
    // staticRoleId: yup.object().required(ErrorMsg('Base Role').required),
    orderLimit: yup.string().max(7, ErrorMsg(7).max),
    departmentId: yup.object().required(ErrorMsg('Department').required),
    // baseRole: yup.string().required('Please select the role.'),
    // departmentName: yup.string(),
    firstName: yup
      .string()
      .required(ErrorMsg('First Name').required)
      .min(2, ErrorMsg(2).min)
      .max(25, ErrorMsg(25).max),
    lastName: yup
      .string()
      .required(ErrorMsg('Last Name').required)
      .min(2, ErrorMsg(2).min)
      .max(25, ErrorMsg(25).max),

    email: yup
      .string()
      .required('Email is required.')
      .matches(
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
        'Please enter a valid email.',
      )
      .max(50, 'Email must be at most 50 characters long.')
      .email('Please enter valid email.'),
    phoneNo: yup
      .string()
      .required(ErrorMsg('Mobile number').required)
      .test(
        'required',
        'Mobile Numbers should be Min 5 and Max 13 characters.',
        value => {
          if (!value) {
            return true;
          } else {
            return value.length > 4;
          }
        },
      )
      .max(13, 'Mobile Numbers should be Min 5 and Max 13 characters.'),
    countryCode: yup.object(),
    startDate: yup.string(),
    endDate: yup
      .string()
      .test(
        'is-endDate-valid',
        'To date should not be before from date',
        function (endDate) {
          const { startDate } = this.parent;
          if (!startDate) return true;
          console.log(
            dayjs(endDate).isAfter(dayjs(startDate)),
            'lkefkb',
            endDate,
            startDate,
          );
          const start = dayjs(new Date(startDate));
          const end = dayjs(new Date(endDate));

          if (!start.isValid() || !end.isValid()) return true;

          // return end.isAfter(start) || end.isSame(start);
          return endDate >= startDate;
        },
      ),
  })
  .required();

// export const AddOrderSchema = yup
//   .object({
//     department: yup.string().required('Department is required'),
//     productionScheduleType: yup
//       .string()
//       .required('Production Schedule Type is required'),
//     setScheduleType: yup.string().required('Set Schedule Type is required'),
//     userType: yup.string().required('User Type is required'),
//     user: yup.string().required('User is required'),
//     startDate: yup
//       .date()
//       .required('Start Date is required')
//       .min(new Date(), 'Start Date cannot be in the past'),
//     startTime: yup.date().required('Start Time is required'),
//     endDate: yup
//       .date()
//       .required('End Date is required')
//       .min(yup.ref('startDate'), 'End Date cannot be before Start Date'),
//     endTime: yup.date().required('End Time is required'),
//     shiftCoverage: yup.string().required('Shift Coverage is required'),
//     notes: yup
//       .string()
//       .required('Notes are required')
//       .max(500, 'Notes cannot exceed 500 characters'),
//   })
//   .required()

export const AddOrderSchema = yup
  .object({
    department: yup.object().required('Department is required'),
    productionScheduleType: yup
      .string()
      .required('Project Schedule Type is required'),
    setScheduleType: yup.string().required('Set Schedule Type is required'),
    userType: yup.string().required('User  Type is required'),
    user: yup.string().required('User  is required'),
    startDate: yup.number().required('Start Date is required'),
    // .min(Date.now(), 'Start Date cannot be in the past'), // Ensure it's a future timestamp
    startTime: yup.string().required('Start Time is required'), // Assuming startTime is also a timestamp
    endDate: yup
      .number()
      .required('End Date is required')
      .min(yup.ref('startDate'), 'End Date cannot be before Start Date'), // Ensure endDate is after startDate
    endTime: yup.string().required('End Time is required'), // Assuming endTime is also a timestamp
    shiftCoverage: yup.string().required('Shift Coverage is required'),
    notes: yup
      .string()
      .test('is-valid-notes', 'Minimum 3 characters required', value => {
        if (!value || value.trim().length === 0) return true; // ✅ If empty, no validation
        return value.length >= 3; // ✅ If present, must be at least 3 characters
      })
      .max(300, 'Notes cannot exceed 300 characters'),
  })
  .required();

export const AddCabOrderSchema = yup
  .object({
    department: yup.object().required('Department is required'),
    productionScheduleType: yup
      .string()
      .required('Project Schedule Type is required'),
    setScheduleType: yup.string().required('Set Schedule Type is required'),
    userType: yup.string().required('User  Type is required'),
    user: yup.string().required('User  is required'),
    startDate: yup.number().required('Pickup Date is required'),
    // .min(Date.now(), 'Start Date cannot be in the past'), // Ensure it's a future timestamp
    // startTime: yup.string().required('Start Time is required'), // Assuming startTime is also a timestamp
    startTime: yup
      .string()
      .required('Pickup Time is required') // Assuming startTime as a string
      .test(
        'Pickup-time-validation',
        'Pickup Time must be at least one hour from now',
        function (value) {
          const { startDate } = this.parent;

          if (!value || !startDate) return false;

          const selectedDate = dayjs(startDate); // Convert startDate to a Day.js object
          const currentTime = dayjs(); // Current time
          const selectedTime = new Date(value);

          console.log('Start Date:', startDate);
          console.log('Start Time:', value);
          console.log('Current Time:', currentTime.format());
          console.log('Selected Time:', selectedTime, selectedDate);
          console.log('Is Same Day:', selectedDate.isSame(currentTime, 'day'));
          console.log(
            'Is After One Hour:',
            dayjs(selectedTime).isAfter(currentTime.add(1, 'hour')),
          );

          // If the start date is today
          if (selectedDate.isSame(currentTime, 'day')) {
            // Check if the selected time is at least 1 hour from now
            return dayjs(selectedTime).isAfter(currentTime.add(1, 'hour'));
          }

          // If the start date is not today, allow any time
          return true;
        },
      ),
    endDate: yup
      .number()
      .required('Dropff Date is required')
      .min(yup.ref('startDate'), 'Dropoff Date cannot be before Start Date'), // Ensure endDate is after startDate
    endTime: yup.string().required('Dropoff Time is required'), // Assuming endTime is also a timestamp
    // shiftCoverage: yup.string().required('Shift Coverage is required'),
    notes: yup
      .string()
      .test('is-valid-notes', 'Minimum 3 characters required', value => {
        if (!value || value.trim().length === 0) return true; // ✅ If empty, no validation
        return value.length >= 3; // ✅ If present, must be at least 3 characters
      })
      .max(300, 'Notes cannot exceed 300 characters'),
  })
  .required();

export const AddStudioSchema = yup.object({
  name: yup
    .string()
    .required(ErrorMsg('Name').required)
    .min(3, ErrorMsg(3).min)
    .max(50, ErrorMsg(50).max),
  address: yup.object().required(ErrorMsg('Address').required),
  addressLine1: yup.string().required('Address Line 1 is required.'),
  locationName: yup.string().required('LocationName is required.'),
  addressLine2: yup.string(),
  zipCode: yup
    .string()
    .required(ErrorMsg('ZipCode').required)
    .max(25, ErrorMsg(25).max),
  city: yup
    .string()
    .required(ErrorMsg('City').required)
    .max(50, ErrorMsg(50).max),
  // country: yup.string().required(ErrorMsg('Country').required),
  state: yup
    .string()
    .max(50, ErrorMsg(50).max)
    .required(ErrorMsg('State').required),
  latitude: yup.string().required('Latitude is required.'),
  longitude: yup.string().required('Longitude is required.'),
});

export const addContactProductionSchema = yup
  .object({
    roleName: yup
      .mixed()
      // Let null (e.g. cleared on department change) reach the test below,
      // instead of yup's own "roleName cannot be null" message
      .nullable()
      .test(
        'roleName-validation',
        'Please select or enter a job title',
        function (value) {
          if (!value) {
            return this.createError({
              message: ErrorMsg('Job Title').required,
            });
          }

          // If it's a string
          if (typeof value === 'string') {
            if (value.length < 3) {
              return this.createError({ message: ErrorMsg(3).min });
            }
            if (value.length > 50) {
              return this.createError({ message: ErrorMsg(50).max });
            }
            return true;
          }

          // If it's an object
          if (typeof value === 'object' && value !== null) {
            const roleName = value.roleName || value.name;
            if (!roleName) {
              return this.createError({
                message: 'Job title name is required',
              });
            }
            if (roleName.length < 3) {
              return this.createError({ message: ErrorMsg(3).min });
            }
            if (roleName.length > 50) {
              return this.createError({ message: ErrorMsg(50).max });
            }
            return true;
          }

          return this.createError({ message: 'Invalid job title format' });
        },
      ),
    // roleName: yup
    //   .string()
    //   .min(3, ErrorMsg(3).min)
    //   .max(50, ErrorMsg(50).max)
    //   .required(ErrorMsg('Job Title').required),
    staticRoleId: yup.object().required('Please select Type.'),
    departmentId: yup.object().required('Please select department.'),
    departmentName: yup.string(),
    baseRole: yup.string().required('Please select the role.'),
    firstName: yup
      .string()
      .required(ErrorMsg('First Name').required)
      // .required(ErrorMsg('First Name').required)
      .max(50, ErrorMsg(50).max),
    lastName: yup
      .string()
      .required(ErrorMsg('Last Name').required)
      // .required(ErrorMsg('Last Name').required)
      .max(50, ErrorMsg(50).max),
    // email: yup
    //   .string()
    //   .required(ErrorMsg('Email').required)
    //   .matches(
    //     /^[\w-]+(?:\.[\w-]+)*@((?:[a-zA-Z]+\.)*[a-zA-Z][a-zA-Z-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$/,
    //     'Please enter a valid email.'
    //   )
    //   .max(100, ErrorMsg(100).max),
    email: yup
      .string()
      .required('Email is required.')
      .matches(
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
        'Please enter a valid email.',
      )
      .max(50, 'Email must be at most 50 characters long.')
      .email('Please enter valid email.'),
    phoneNo: yup
      .string()
      .required(ErrorMsg('Mobile Number').required)
      .test('required', 'Phone no less then 5 digits', value => {
        if (!value) {
          return true;
        } else {
          return value.length > 4;
        }
      })
      .max(13, ErrorMsg(13).max),
    countryCode: yup.object(),
    // roleName: yup
    //   .object()
    //   .shape({
    //     _id: yup.string().required('Role ID is required'),
    //     roleName: yup.string().required('Role name is required'),
    //     departmentId: yup.string().required('Department ID is required'),
    //   })
    //   .required('Please select a role.'),
  })
  .required();

export const addCrewProductionSchema = yup
  .object({
    roleName: yup
      .mixed()
      // Let null (e.g. cleared on department change) reach the test below,
      // instead of yup's own "roleName cannot be null" message
      .nullable()
      .test(
        'roleName-validation',
        'Please select or enter a job title',
        function (value) {
          if (!value) {
            return this.createError({
              message: ErrorMsg('Job Title').required,
            });
          }

          // If it's a string
          if (typeof value === 'string') {
            if (value.length < 3) {
              return this.createError({ message: ErrorMsg(3).min });
            }
            if (value.length > 50) {
              return this.createError({ message: ErrorMsg(50).max });
            }
            return true;
          }

          // If it's an object
          if (typeof value === 'object' && value !== null) {
            const roleName = value.roleName || value.name;
            if (!roleName) {
              return this.createError({
                message: 'Job title name is required',
              });
            }
            if (roleName.length < 3) {
              return this.createError({ message: ErrorMsg(3).min });
            }
            if (roleName.length > 50) {
              return this.createError({ message: ErrorMsg(50).max });
            }
            return true;
          }

          return this.createError({ message: 'Invalid job title format' });
        },
      ),
    staticRoleId: yup.object().required('Please select Type.'),
    departmentId: yup.object().required('Please select department.'),
    departmentName: yup.string(),
    baseRole: yup.string().required('Please select the role.'),
    firstName: yup
      .string()
      .required(ErrorMsg('First Name').required)
      // .required(ErrorMsg('First Name').required)
      .max(50, ErrorMsg(50).max),
    lastName: yup
      .string()
      .required(ErrorMsg('Last Name').required)
      // .required(ErrorMsg('Last Name').required)
      .max(50, ErrorMsg(50).max),
    // email: yup
    //   .string()
    //   .required(ErrorMsg('Email').required)
    //   .matches(
    //     /^[\w-]+(?:\.[\w-]+)*@((?:[a-zA-Z]+\.)*[a-zA-Z][a-zA-Z-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$/,
    //     'Please enter a valid email.'
    //   )
    //   .max(100, ErrorMsg(100).max),
    email: yup
      .string()
      .required('Email is required.')
      .matches(
        /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
        'Please enter a valid email.',
      )
      .max(50, 'Email must be at most 50 characters long.')
      .email('Please enter valid email.'),
    phoneNo: yup
      .string()
      .required(ErrorMsg('Mobile Number').required)
      .test('required', 'Phone no less then 5 digits', value => {
        if (!value) {
          return true;
        } else {
          return value.length > 4;
        }
      })
      .max(13, ErrorMsg(13).max),
    countryCode: yup.object(),
  })
  .required();

// Evaluated at validation time (not module load) so "now" is never stale.
const getStartOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today.getTime();
};

// startDate is a midnight timestamp; combine it with the picked time of day
// and check the result is in the future.
const isStartDateTimeInFuture = (startDate: any, startTime: any) => {
  const date = new Date(startDate);
  const time = new Date(startTime);
  if (isNaN(date.getTime()) || isNaN(time.getTime())) return true; // handled by required rules
  date.setHours(time.getHours(), time.getMinutes(), 0, 0);
  return date.getTime() > Date.now();
};

export const UpdateServicePeriodSchema = yup
  .object({
    startDate: yup
      .number()
      .transform((value, originalValue) => Date.parse(originalValue) || value) // Convert date string to timestamp
      .required('Start Date is required')
      .test(
        'start-date-not-past',
        'Start date cannot be in the past.',
        value => !value || value >= getStartOfToday(),
      ),
    startTime: yup
      .string()
      .required('Start Time is required')
      .test(
        'start-time-in-future',
        'Start time must be greater than the current time.',
        function (value) {
          return isStartDateTimeInFuture(this.parent.startDate, value);
        },
      ),
    endDate: yup
      .number()
      .transform((value, originalValue) => Date.parse(originalValue) || value) // Convert date string to timestamp
      .required('End Date is required')
      .min(yup.ref('startDate'), 'End Date cannot be less than Start Date.'), // Ensure endDate is after startDate
    endTime: yup.string().required('End Time is required'), // Assuming endTime is also a timestamp
    shiftCoverage: yup.string().required('Shift Coverage is required'),
  })
  .required();

export const UpdateServicePeriodSchemaInCart = yup
  .object({
    startDate: yup
      .number()
      .transform((value, originalValue) => Date.parse(originalValue) || value) // Convert date string to timestamp
      .required('Start Date is required')
      .test(
        'start-date-not-past',
        'Start date cannot be in the past.',
        value => !value || value >= getStartOfToday(),
      ),
    startTime: yup
      .string()
      .required('Start Time is required')
      .test(
        'start-time-in-future',
        'Start time must be greater than the current time.',
        function (value) {
          // Fixed cost (Daily/Weekly) shifts always run 12:00 AM - 11:59 PM and
          // their time isn't user-editable, so the current-time check doesn't apply.
          if (this.options.context?.isFixedCost) return true;
          return isStartDateTimeInFuture(this.parent.startDate, value);
        },
      ),
    endDate: yup
      .number()
      .transform((value, originalValue) => Date.parse(originalValue) || value) // Convert date string to timestamp
      .required('End Date is required')
      .min(yup.ref('startDate'), 'End Date cannot be less than Start Date.'), // Ensure endDate is after startDate
    endTime: yup.string().required('End Time is required'), // Assuming endTime is also a timestamp
    shiftCoverage: yup.string().required('Shift Coverage is required'),
  })
  .required();

export const UploadDocumentScheme = yup
  .object({
    documentName: yup.string().required('Document Name is required'),
    production: yup.object().nullable().notRequired(),
    episode: yup.object().nullable().notRequired(),
    set: yup.object().nullable().notRequired(),
    location: yup.object().nullable().notRequired(),
    deptId: yup.object().required('Department is required'),
    documentUrl: yup.string().test({
      name: 'documentUrlValidation',
      test: function (value, _context) {
        const { hasUploadedFile } = this.options.context || {};

        // If a file is uploaded, URL is not required
        if (hasUploadedFile) {
          return true;
        }

        // Validate URL format if provided
        if (value && !yup.string().url().isValidSync(value)) {
          return this.createError({
            message: 'Please enter a valid URL',
            path: 'documentUrl',
          });
        }

        return true;
      },
    }),
  })
  .required();

// Start an order

const validFileExtensions = ['doc', 'jpg', 'jpeg', 'png', 'pdf', 'xls', 'xlsx'];

const isRentedPerHour = (shoppingMode: any, _priceMode: any) =>
  shoppingMode === `${PRODUCT_TYPES.SERVICE}-${RENTAL_SERVICE_TYPE.RENT}` ||
  shoppingMode === `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.RENT}`;

export const startOrderSchema = yup.object().shape({
  shoppingMode: yup.string().optional(),
  priceMode: yup.mixed().optional(),
  Production: yup
    .mixed()
    .transform((value, originalValue) => {
      if (originalValue && originalValue._id) {
        return originalValue.name;
      }
      return value;
    })
    .required('Project is mandatory'),

  Location: yup.mixed().nullable().required('Location is mandatory'),

  Department: yup.mixed().nullable().required('Department is mandatory'),

  'Production Schedule': yup
    .mixed()
    .nullable()
    .required('Project Schedule is mandatory'),

  'Set Schedule': yup.mixed().nullable().required('Set Schedule is mandatory'),

  'Start Date': yup.date().when('shoppingMode', {
    is: val =>
      val != `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.BUY}` &&
      val !== `${PRODUCT_TYPES.PRODUCT}-${RENTAL_SERVICE_TYPE.BUY}`,
    then: s => s.required('Start Date is mandatory'),

    otherwise: s => s.nullable().notRequired(),
  }),

  'Start Time': yup
    .string()
    .transform((value, originalValue) => {
      if (dayjs.isDayjs(originalValue)) {
        return originalValue.format('HH:mm');
      }
      return value;
    })

    .when(['shoppingMode', 'priceMode'], {
      is: (val, priceMode) => isRentedPerHour(val, priceMode),

      then: s => s.required('Start time is mandatory'),
      otherwise: s => s.notRequired().nullable(),
    }),

  'End Date': yup.date().when('shoppingMode', {
    is: val =>
      val != `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.BUY}` &&
      val !== `${PRODUCT_TYPES.PRODUCT}-${RENTAL_SERVICE_TYPE.BUY}`,
    then: s => s.required('End Date is mandatory'),
    otherwise: s => s.nullable().notRequired(),
  }),

  'End Time': yup
    .string()
    .transform((value, originalValue) => {
      if (dayjs.isDayjs(originalValue)) {
        return originalValue.format('HH:mm');
      }
      return value;
    })
    .when(['shoppingMode', 'priceMode'], {
      is: (val, priceMode) => isRentedPerHour(val, priceMode),
      then: s =>
        s
          .required('End time is mandatory')
          .test(
            'endDatelessStartData',
            'End Date cannot be less than Start Date',
            function (value) {
              const { 'End Date': endDate, 'Start Date': startDate } =
                this.parent;

              if (!value || !startDate || !endDate) return true;

              const startDateOnly = dayjs(startDate);
              const endDateOnly = dayjs(endDate);

              return !endDateOnly.isBefore(startDateOnly);
            },
          )
          .test(
            'endTimeEqualStartTime',
            'End time & Start time cannot be same.',
            function (value) {
              const {
                'End Date': endDate,
                'Start Date': startDate,
                'Start Time': startTime,
              } = this.parent;

              if (!value || !startTime || !startDate || !endDate) return true;

              const startDateOnly = dayjs(startDate).format('YYYY-MM-DD');
              const endDateOnly = dayjs(endDate).format('YYYY-MM-DD');

              const startDateTime = dayjs(
                `${startDateOnly} ${startTime}`,
                'YYYY-MM-DD HH:mm',
              );
              const endDateTime = dayjs(
                `${endDateOnly} ${value}`,
                'YYYY-MM-DD HH:mm',
              );

              if (!startDateTime.isValid() || !endDateTime.isValid())
                return false;

              return !endDateTime.isSame(startDateTime);
            },
          )
          .test(
            'endTimeAfterStartTime',
            'End time cannot be less than Start time.',
            function (value) {
              const {
                'End Date': endDate,
                'Start Date': startDate,
                'Start Time': startTime,
              } = this.parent;

              if (!value || !startTime || !startDate || !endDate) return true;

              const startDateOnly = dayjs(startDate).format('YYYY-MM-DD');
              const endDateOnly = dayjs(endDate).format('YYYY-MM-DD');

              const startDateTime = dayjs(
                `${startDateOnly} ${startTime}`,
                'YYYY-MM-DD HH:mm',
              );
              const endDateTime = dayjs(
                `${endDateOnly} ${value}`,
                'YYYY-MM-DD HH:mm',
              );

              if (!startDateTime.isValid() || !endDateTime.isValid())
                return false;

              return endDateTime.isAfter(startDateTime);
            },
          )
          .test(
            'startTimeAfterCurrentTime',
            'Start time must be greater than current time.',
            function () {
              const {
                'Start Date': startDate,
                'Start Time': startTime,
                priceMode,
              } = this.parent;
              if (
                priceMode?.priceMode !== 'PER_HOUR' ||
                !priceMode?.shiftLength
              )
                return true;
              if (!startDate || !startTime) return true; // skip if no data
              const startDateTime = dayjs(
                `${dayjs(startDate).format('YYYY-MM-DD')} ${startTime}`,
                'YYYY-MM-DD HH:mm',
              );
              return startDateTime.isValid() && startDateTime.isAfter(dayjs());
            },
          ),
      otherwise: s => s.notRequired().nullable(),
    }),

  Coverage: yup.string(),
  // .when('shoppingMode', {
  //   is: val =>
  //     val == `${PRODUCT_TYPES.SERVICE}-${RENTAL_SERVICE_TYPE.RENT}` ||
  //     val === `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.RENT}`,
  //   then: s => s.required('Coverage is mandatory'),
  //   otherwise: s => s.notRequired().nullable(),
  // }),

  Notes: yup
    .string()
    .notRequired()
    .test('notesLength', 'Min 3  characters are allowed.', value => {
      return (
        value === undefined ||
        value === '' ||
        (value.length >= 3 && value.length <= 300)
      );
    }),
  Attachments: yup
    .array()
    .of(
      yup
        .mixed()
        .test(
          'fileFormat',
          'File formats should be doc, Jpg, Jpeg,png, pdf, xls,xlsx',
          value => {
            if (!value) return true;
            const ext = value.docName.split('.').pop()?.toLowerCase() || '';
            return validFileExtensions.includes(ext);
          },
        ),
    )
    .max(5, 'Maximum 5 attachments are allowed')
    .test('fileSize', 'File size cannot be more than 10MB', value => {
      if (!value) return true;
      const totalSize = value.reduce((sum, file) => sum + (file?.size || 0), 0);
      return totalSize <= 10 * 1024 * 1024;
    }),
});

export const addMoreItemsSchema = yup.object().shape({
  addMoreItems: yup
    .array()
    .of(
      yup.object().shape({
        shoppingMode: yup.string().optional(),
        priceMode: yup.mixed().optional(),
        Production: yup
          .mixed()
          .transform((value, originalValue) => {
            if (originalValue && originalValue._id) {
              return originalValue.name;
            }
            return value;
          })
          .required('Project is mandatory'),

        Location: yup.mixed().nullable().required('Location is mandatory'),

        Department: yup.mixed().nullable().required('Department is mandatory'),

        productionSchedule: yup
          .mixed()
          .nullable()
          .required('Project Schedule is mandatory'),

        setSchedule: yup
          .mixed()
          .nullable()
          .required('Set Schedule is mandatory'),

        startDate: yup.date().when('shoppingMode', {
          is: val => {
            return (
              val != `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.BUY}` &&
              val !== `${PRODUCT_TYPES.PRODUCT}-${RENTAL_SERVICE_TYPE.BUY}`
            );
          },
          then: s => s.required('Start Date is mandatory'),
          otherwise: s => s.nullable().notRequired(),
        }),

        startTime: yup
          .mixed()
          .transform((value, originalValue) => {
            if (dayjs.isDayjs(originalValue)) {
              return originalValue.format('HH:mm');
            }
            return value;
          })
          .when(['shoppingMode', 'priceMode'], {
            is: (val, priceMode) => isRentedPerHour(val, priceMode),
            then: s => s.required('Start time is mandatory'),
            otherwise: s => s.notRequired().nullable(),
          }),

        endDate: yup.date().when('shoppingMode', {
          is: val =>
            val != `${PRODUCT_TYPES.PACKAGE}-${RENTAL_SERVICE_TYPE.BUY}` &&
            val !== `${PRODUCT_TYPES.PRODUCT}-${RENTAL_SERVICE_TYPE.BUY}`,
          then: s => s.required('End Date is mandatory'),
          otherwise: s => s.nullable().notRequired(),
        }),

        endTime: yup
          .mixed()
          .transform((value, originalValue) => {
            if (dayjs.isDayjs(originalValue)) {
              return originalValue.format('HH:mm');
            }
            return value;
          })
          .when(['shoppingMode', 'priceMode'], {
            is: (val, priceMode) => isRentedPerHour(val, priceMode),
            then: s =>
              s
                .required('End time is mandatory')

                .test(
                  'endDatelessStartData',
                  'End Date cannot be less than Start Date',
                  function (value) {
                    const { endDate: endDate, startDate: startDate } =
                      this.parent;
                    if (!value || !startDate || !endDate) return true;
                    const startDateOnly = dayjs(startDate);
                    const endDateOnly = dayjs(endDate);
                    return !endDateOnly.isBefore(startDateOnly);
                  },
                )
                .test(
                  'endTimeEqualStartTime',
                  'End time & Start time cannot be same.',
                  function (value) {
                    const {
                      endDate: endDate,
                      startDate: startDate,
                      startTime: startTime,
                    } = this.parent;

                    if (!value || !startTime || !startDate || !endDate)
                      return true;

                    const startDateOnly = dayjs(startDate).format('YYYY-MM-DD');
                    const endDateOnly = dayjs(endDate).format('YYYY-MM-DD');

                    const startDateTime = dayjs(
                      `${startDateOnly} ${startTime}`,
                      'YYYY-MM-DD HH:mm',
                    );
                    const endDateTime = dayjs(
                      `${endDateOnly} ${value}`,
                      'YYYY-MM-DD HH:mm',
                    );

                    if (!startDateTime.isValid() || !endDateTime.isValid())
                      return false;

                    return !endDateTime.isSame(startDateTime);
                  },
                )
                .test(
                  'endTimeAfterStartTime',
                  'End time cannot be less than Start time.',
                  function (value) {
                    const {
                      endDate: endDate,
                      startDate: startDate,
                      startTime: startTime,
                    } = this.parent;

                    if (!value || !startTime || !startDate || !endDate)
                      return true;

                    const startDateOnly = dayjs(startDate).format('YYYY-MM-DD');
                    const endDateOnly = dayjs(endDate).format('YYYY-MM-DD');

                    const startDateTime = dayjs(
                      `${startDateOnly} ${startTime}`,
                      'YYYY-MM-DD HH:mm',
                    );
                    const endDateTime = dayjs(
                      `${endDateOnly} ${value}`,
                      'YYYY-MM-DD HH:mm',
                    );

                    if (!startDateTime.isValid() || !endDateTime.isValid())
                      return false;

                    return endDateTime.isAfter(startDateTime);
                  },
                )
                .test(
                  'startTimeAfterCurrentTime',
                  'Start time must be greater than current time.',
                  function () {
                    const {
                      startDate: startDate,
                      startTime: startTime,
                      priceMode,
                    } = this.parent;
                    if (
                      priceMode?.priceMode !== 'PER_HOUR' ||
                      !priceMode?.shiftLength
                    )
                      return true;
                    if (!startDate || !startTime) return true;
                    const startDateTime = dayjs(
                      `${dayjs(startDate).format('YYYY-MM-DD')} ${startTime}`,
                      'YYYY-MM-DD HH:mm',
                    );
                    return (
                      startDateTime.isValid() && startDateTime.isAfter(dayjs())
                    );
                  },
                ),
            otherwise: s => s.notRequired().nullable(),
          }),

        coverage: yup.string(),
        rateModel: yup.mixed().nullable(),
        shiftModel: yup.mixed().nullable(),

        note: yup
          .string()
          .nullable()
          .test(
            'notesLength',
            'Min 3 characters and max 300 allowed.',
            value => {
              if (!value) return true; // allow empty / null
              return value.length >= 3 && value.length <= 300;
            },
          ),

        attachments: yup
          .array()
          .of(
            yup
              .mixed()
              .test(
                'fileFormat',
                'File formats should be doc, Jpg, Jpeg,png, pdf, xls,xlsx',
                value => {
                  if (!value) return true;
                  const ext =
                    value.docName.split('.').pop()?.toLowerCase() || '';
                  return validFileExtensions.includes(ext);
                },
              ),
          )
          .max(5, 'Maximum 5 attachments are allowed')
          .test('fileSize', 'File size cannot be more than 10MB', value => {
            if (!value) return true;
            const totalSize = value.reduce(
              (sum, file) => sum + (file?.size || 0),
              0,
            );
            return totalSize <= 10 * 1024 * 1024;
          }),
      }),
    )
    .min(1, 'At least one item is required'),
});

/** One extend-service range (Orders edit shift + Cart worksheet extend rows) */
export const extendServiceDateRangeSchema = yup.object({
  startDate: yup
    .mixed()
    .required('Start date is required')
    .test('is-dayjs', 'Invalid start date', value => {
      return value === null || dayjs.isDayjs(value);
    }),
  endDate: yup
    .mixed()
    .required('End date is required')
    .test('is-dayjs', 'Invalid end date', value => {
      return value === null || dayjs.isDayjs(value);
    })
    .test(
      'end-after-start',
      'End date must be after start date',
      function (value) {
        const { startDate } = this.parent;
        if (!startDate || !value) return true;
        return (
          dayjs(value).isAfter(dayjs(startDate)) ||
          dayjs(value).isSame(dayjs(startDate), 'day')
        );
      },
    ),
});

// Form validation schema for edit shift
export const editShiftSchema = yup.object({
  startTime: yup
    .mixed()
    .required('Start time is required')
    .test('is-dayjs', 'Invalid start time', value => {
      return value === null || dayjs.isDayjs(value);
    }),
  endTime: yup
    .mixed()
    .required('End time is required')
    .test('is-dayjs', 'Invalid end time', value => {
      return value === null || dayjs.isDayjs(value);
    }),
  // .test(
  //   'end-after-start',
  //   'End time must be after start time',
  //   function (value) {
  //     const { startTime } = this.parent;
  //     if (!startTime || !value) return true;
  //     return dayjs(value).isAfter(dayjs(startTime));
  //   },
  // ),
  notes: yup
    .string()
    .max(1000, 'Max 1000 characters')
    .test(
      'not-only-spaces',
      'Notes cannot contain only spaces',
      value => !value || value.trim().length > 0,
    )
    .optional(),

  extendDates: yup.array().of(extendServiceDateRangeSchema).optional(),
});

export const vendorRequestFormSchema = yup.object({
  companyName: yup
    .string()
    .required('Company Name is required')
    .matches(
      /^[A-Za-z0-9 .&-]+$/,
      'Company Name can only contain letters, numbers, spaces, dots (.), hyphens (-), and ampersands (&)',
    )
    .min(2, 'Company Name must be at least 2 characters')
    .max(100, 'Company Name cannot exceed 100 characters')
    .trim('No leading or trailing spaces allowed'),

  companyEmail: yup
    .string()
    .required('Company Email Address is required')
    .email('Please enter a valid email address'),

  companyNumber: yup
    .string()
    .required('Company Number is required')
    .matches(
      /^[+0-9\s-]{5,13}$/,
      'Company Number should be Min 5 and Max 13 characters.',
    ),

  city: yup
    .string()
    .required('City is required')
    .matches(/^[A-Za-z ]+$/, 'City can only contain alphabets and spaces')
    .max(50, 'City cannot exceed 50 characters'),

  // state: yup
  //   .string()
  //   .required("State is required")
  //   .matches(/^[A-Za-z ]+$/, "State can only contain alphabets and spaces")
  //   .max(50, "State cannot exceed 50 characters"),

  // country: yup
  //   .string()
  //   .required("Country is required")
  //   .matches(/^[A-Za-z ]+$/, "Country can only contain alphabets and spaces")
  //   .max(50, "Country cannot exceed 50 characters"),

  companyWebsite: yup
    .string()
    .required('Company Website is required')
    .matches(
      /^(https?:\/\/)[\w.-]+\.[a-z]{2,}.*$/i,
      'Please enter a valid URL starting with http:// or https://',
    ),

  production: yup
    .string()
    .required('Project is required')
    .matches(
      /^[A-Za-z0-9 -]+$/,
      'Project can only contain alphabets, numbers, spaces, and hyphens (-)',
    )
    .min(2, 'Project must be at least 2 characters')
    .max(100, 'Project cannot exceed 100 characters'),

  productionContactName: yup
    .string()
    .required('Project Contact Name is required')
    .matches(
      /^[A-Za-z ]+$/,
      'Project Contact Name can only contain alphabets and spaces',
    )
    .min(2, 'Project Contact Name must be at least 2 characters')
    .max(50, 'Project Contact Name cannot exceed 50 characters'),

  productionCompanyNumber: yup
    .string()
    .required('Project Company Number is required')
    .matches(
      /^[+0-9\s-]{7,15}$/,
      'Project Company Number must contain only digits and can include +, -, or spaces (7–15 digits total)',
    ),

  productionEmail: yup
    .string()
    .required('Project Email Address is required')
    .email('Please enter a valid email address'),

  startDate: yup
    .date()
    .required('Start Date is required')
    .typeError('Invalid date format (use YYYY-MM-DD)')
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      'Start Date cannot be in the past',
    ),
});

/** Autocomplete / select: null, {}, or missing value|label should not satisfy "required". */
function isThreatSubcategorySelectFilled(value: unknown): boolean {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    const v = o.value ?? o.label;
    if (v == null) return false;
    return String(v).trim().length > 0;
  }
  return false;
}

// Thread SubCategory Schema
export const ThreatSubcategorySchema = yup.object().shape({
  threatSubcategoryName: yup.mixed().required('Threat Subcategory is required'),
  riskRating: yup.mixed().required('Risk Rating is required'),
  threatDescription: yup
    .string()
    .trim()
    .required('Threat Description is required')
    .min(10, 'Threat Description must be at least 10 characters')
    .max(5000, 'Threat Description must be at most 5000 characters'),

  status: yup.mixed().required('Status is required'),
  actionable: yup
    .mixed()
    .required('Actionable field is required')
    .test('actionable-selected', 'Actionable field is required', val =>
      isThreatSubcategorySelectFilled(val),
    ),
  supportingInformation: yup
    .string()
    .trim()
    .nullable()
    .optional()
    .max(100, 'Supporting Information must be at most 100 characters'),

  sourceInformation: yup.mixed().optional().nullable(),
  // .test(
  //   'all-keys-true',
  //   'At least one source information options must be selected',
  //   value => {
  //     // If value is not an object, fail validation
  //     if (typeof value !== 'object' || value === null) return false;

  //     // Check all keys have `true` value
  //     return Object.values(value).some(v => v === true);
  //   },
  // )
  // .required('Select at least one source information'),

  mitigationAndResponsePlan: yup
    .string()
    .trim()
    .optional()
    .nullable()
    .max(5000, 'Mitigation & Response Plan must be at most 5000 characters'),
  additionalContext: yup
    .string()
    .trim()
    .optional()
    .nullable()
    .max(5000, 'Mitigation & Response Plan must be at most 5000 characters'),

  attachments: yup
    .array()
    .max(5, 'Maximum 5 files allowed')
    .of(
      yup
        .mixed()
        .test('fileSize', 'File size must be less than 25MB', file => {
          if (!file) return true;
          return file.size <= 25 * 1024 * 1024;
        })
        .test('fileFormat', 'Unsupported file type', file => {
          if (!file) return true;

          const allowedTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/jpg',
            'video/mp4',
            'application/msword', // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ];
          return allowedTypes.includes(file.type);
        }),
    )

    .nullable(),
  load: yup.boolean().default(false),
  uploadProgress: yup.mixed().default(null).nullable(),
  other: yup
    .string()
    .trim()
    .nullable()
    .max(100, 'Additional Information must be at most 100 characters')
    .when('sourceInformation', {
      is: (src: any) => src?.other === true,
      then: schema =>
        schema.required(
          'Additional Information is required when "Other" is selected',
        ),

      otherwise: schema => schema.notRequired(),
    }),
  otherLocation: yup.object().when('location', {
    is: (location: any) => (location?._id == 'OTHERS' ? true : false),
    then: _schema => otherLocationSchema.required(),
    otherwise: schema => schema.strip(), //  removes from payload
  }),
  location: yup.mixed().nullable().notRequired(),
  addressLine1: yup.string().when('location', {
    is: (val: any) => !!val,
    then: schema => schema.required('Address Line 1 is required'),
    otherwise: schema => schema.notRequired(),
  }),

  // Address Line 2 (always optional)
  addressLine2: yup.string().nullable().notRequired(),

  // City
  city: yup.string().when('location', {
    is: (val: any) => !!val,
    then: schema => schema.required('City is required'),
    otherwise: schema => schema.notRequired(),
  }),

  // State
  state: yup.string().when('location', {
    is: (val: any) => !!val,
    then: schema => schema.required('State is required'),
    otherwise: schema => schema.notRequired(),
  }),

  // Postal Code
  postalCode: yup.string().when('location', {
    is: (val: any) => !!val,
    then: schema => schema.required('Postal Code is required'),
    otherwise: schema => schema.notRequired(),
  }),
});

/** No subcategory selected — row skips strict validation and does not count as "complete". */
function isThreatSubcategoryRowEmpty(sub: unknown): boolean {
  if (sub == null || typeof sub !== 'object') return true;
  const o = sub as Record<string, unknown>;
  const tsn = o.threatSubcategoryName;
  if (tsn == null) return true;
  if (typeof tsn === 'string') return tsn.trim() === '';
  if (typeof tsn === 'object') {
    const obj = tsn as Record<string, unknown>;
    const name = obj.threatSubcategoryName ?? obj.name;
    if (name != null && String(name).trim() !== '') return false;
    if (obj._id != null && String(obj._id).trim() !== '') return false;
    return true;
  }
  return false;
}

const quickThreatAlertAssessmentSchema = yup.object().shape({
  ...ThreatSubcategorySchema.fields,
  threatType: yup.mixed().required('Threat Type is required'),
});

/** True if some row fully passes quick-threat row schema (used by lazy array items). */

/**
 * Empty rows use yup.mixed() so extra blank "Add assessment" rows don't all error — unless
 * no row is complete; then the first empty row must use the full schema so field errors show on submit.
 */

//   genaral Statement Schema
// export const generalAssessmentSchema = yup.object().shape({
//   threatDescription: yup
//     .string()
//     .trim()
//     .required('Threat Description is required')
//     .min(30, 'Threat Description must be at least 30 characters')
//     .max(5000, 'Threat Description must be at most 5000 characters'),
//   riskRating: yup.mixed().required('Risk Rating is required'),
//   status: yup.mixed().required('Status is required'),
//   actionable: yup.mixed().required('Actionable field is required'),
//   // indicators: yup.array().of(yup.string()).required('Indicators are required'),
//   supportingInformation: yup
//     .string()
//     .trim()
//     .optional()
//     .nullable()
//     .max(100, 'Supporting Information must be at most 100 characters'),
//   sourceInformation: yup.mixed().optional().nullable(),
//   // .test(
//   //   'all-keys-true',
//   //   'At least one source information options must be selected',
//   //   value => {
//   //     // If value is not an object, fail validation
//   //     if (typeof value !== 'object' || value === null) return false;

//   //     // Check all keys have `true` value
//   //     return Object.values(value).some(v => v === true);
//   //   },
//   // )
//   // .required('Select at least one source information'),

//   mitigationAndResponsePlan: yup
//     .string()
//     .trim()
//     .optional()
//     .nullable()
//     .max(5000, 'Mitigation & response plan must be at most 5000 characters'),

//   attachments: yup
//     .array()
//     .max(5, 'Maximum 5 files allowed')
//     .of(
//       yup
//         .mixed()
//         .test('fileSize', 'File size must be less than 25MB', file => {
//           if (!file) return true;
//           return file?.size <= 25 * 1024 * 1024;
//         })
//         .test('fileFormat', 'Unsupported file type', file => {
//           if (!file) return true;

//           const allowedTypes = [
//             'application/pdf',
//             'image/png',
//             'image/jpeg',
//             'image/jpg',
//             'video/mp4',
//             'application/msword', // .doc
//             'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
//           ];
//           return allowedTypes.includes(file?.type);
//         }),
//     )
//     .nullable(),
//   load: yup.boolean().default(false),
//   uploadProgress: yup.mixed().default(null).nullable(),
//   other: yup
//     .string()
//     .trim()
//     .nullable()
//     .max(100, 'Additional Information must be at most 100 characters')
//     .when('sourceInformation', {
//       is: (src: any) => src?.other === true,
//       then: schema =>
//         schema.required(
//           'Additional Information is required when "Other" is selected',
//         ),

//       otherwise: schema => schema.notRequired(),
//     }),
// });

const threatCategorySchema = yup.object().shape({
  type: yup.string().optional(),
  // Use lazy + full row schema so field errors (e.g. threatDescription min) nest under
  // threatClassification.N.subCategories.M.* for RHF — mixed().test only produced a single
  // row-level .message and the description TextField never saw errors while typing.
  subCategories: yup
    .array()
    .of(
      yup.lazy((value: unknown) => {
        if (isThreatSubcategoryRowEmpty(value)) {
          return yup.mixed();
        }
        return ThreatSubcategorySchema;
      }),
    )
    .default([]),
  order: yup.number().default(0).nullable(),
  threatId: yup.string().default('').nullable(),
});

const otherLocationSchema = yup.object().shape({
  location: yup.mixed().required('Location is required'),
  addressLine1: yup.string().required('Address Line 1 is required'),
  addressLine2: yup.string().nullable(), // optional
  cityTown: yup.string().required('City is required'),
  stateProvince: yup.string().required('State is required'),
  postalCode: yup.string().required('Postal Code is required'),
});

export const threatReportSchema = yup.object().shape({
  // -------------------- REPORTER INFORMATION --------------------

  reporterInfo: yup.object().shape({
    organisation: yup.mixed().required('Organization is required'),

    reporterName: yup.mixed().required('Reporter Name is required'),
    analystEmail: yup
      .string()
      .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Enter a valid email')
      .required('Analyst Email is required'),

    // reportDate: yup.date().required('Report Date is required'),
    // reportTime: yup
    //   .string()
    // .transform((value, originalValue) => {
    //   if (dayjs.isDayjs(originalValue)) {
    //     return originalValue.format('HH:mm');
    //   }
    //   return value;
    // })
    // .required('Report Time is required'),
    // .test(
    //   'not-in-past',
    //   'Report Date & Time cannot be in the past',
    //   function (value) {
    //     const { reportDate } = this.parent; // ✅ access sibling field

    //     if (!value || !reportDate) return true; // skip if missing; handled by required()

    //     // Parse both date and time
    //     const datePart = dayjs(reportDate);
    //     const timePart = dayjs(value, 'HH:mm');

    //     // Combine into a single datetime
    //     const combinedDateTime = datePart
    //       .hour(timePart.hour())
    //       .minute(timePart.minute())
    //       .second(0)
    //       .millisecond(0);

    //     const now = dayjs();

    //     // Valid if in future or same moment
    //     return combinedDateTime.isAfter(now) || combinedDateTime.isSame(now);
    //   },
    // ),
  }),

  // -------------------- LOCATION INFORMATION --------------------
  locationInfo: yup.object().shape({
    productionName: yup.mixed().required('Project Name is required'),
    setActivity: yup.mixed().required('Set/Activity is required'),
    location: yup.mixed().required('Location is required'),
    episode: yup.mixed().nullable(),
    addressLine1: yup.string(),
    addressLine2: yup.string().nullable(),

    city: yup.string(),
    state: yup.string(),

    postalCode: yup.string(),
  }),

  // -------------------- OTHERS LOCATION (conditional) --------------------
  otherLocation: yup.object().when('$isOthersSelected', {
    is: true,
    then: _schema => otherLocationSchema.required(),
    otherwise: schema => schema.strip(), // 💥 removes from payload
  }),

  // -------------------- EXECUTIVE SUMMARY --------------------
  executiveSummary: yup
    .string()
    .trim()
    .required('Executive Summary is required')
    .min(10, 'Executive Summary must be at least 10 characters')
    .max(5000, 'Executive Summary must be at most 5000 characters'),

  // -------------------- Threat Type --------------------

  threatClassification: yup
    .array()
    .of(threatCategorySchema)
    .min(1, 'At least one threat assessment type is required')
    .required('Threat Classification is required')
    .test(
      'at-least-one-complete-subcategory',
      'Complete at least one threat subcategory in any assessment type',
      function (list) {
        if (!Array.isArray(list)) return false;
        for (const cat of list) {
          const subs = cat?.subCategories;
          if (!Array.isArray(subs)) continue;
          for (const sub of subs) {
            if (isThreatSubcategoryRowEmpty(sub)) continue;
            try {
              ThreatSubcategorySchema.validateSync(sub, { abortEarly: false });
              return true;
            } catch {
              /* keep looking for another complete row */
            }
          }
        }
        return false;
      },
    ),

  additionalAttachments: yup
    .array()
    .max(5, 'Maximum 5 files allowed')
    .of(
      yup
        .mixed()
        .test('fileSize', 'File size must be less than 25MB', file => {
          if (!file) return true;
          return file.size <= 25 * 1024 * 1024;
        })
        .test('fileFormat', 'Unsupported file type', file => {
          if (!file) return true;

          const allowedTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/jpg',
            'video/mp4',
            'application/msword', // .doc
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
          ];

          return allowedTypes.includes(file.type);
        }),
    )
    .nullable(),
  load: yup.boolean().default(false),
  uploadProgress: yup.mixed().default(null).nullable(),
});

export const threatReportAlert = yup.object().shape({
  ...threatReportSchema.fields,
  threatClassification: yup
    .array()
    .of(quickThreatAlertAssessmentSchema)
    .min(1, 'At least one threat assessment is required')
    .required('Threat Classification is required'),

  executiveSummary: yup.string().optional().nullable(),
});
export const poNumberSchema = yup.object({
  poNumber: yup
    .string()
    .trim()
    .optional()
    .matches(
      /^[A-Za-z0-9-]{2,25}$/,
      'PO must be 2–25 characters, alphanumeric and dashes only',
    ),
});
